import React from 'react';
import { Link } from 'react-router-dom';

const MAX_ITEMS = 5;

export default function TrendingArticles({ articles }) {
  const items = (articles || []).slice(0, MAX_ITEMS);

  return (
    <section className="sidebar-section">
      <h2 className="section-heading">Trending Articles</h2>

      {items.length === 0 ? (
        <p className="state-message">Nothing trending yet.</p>
      ) : (
        <ol className="trending-list">
          {items.map((article, i) => (
            <li key={article.id} className="trending-list__item">
              <span className="trending-list__rank">{i + 1}</span>
              <Link to={`/articles/${article.documentId}`} className="trending-list__title">
                {article.title}
              </Link>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
